import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqItems = [
  { qKey: "faq.q1", aKey: "faq.a1" },
  { qKey: "faq.q2", aKey: "faq.a2" },
  { qKey: "faq.q3", aKey: "faq.a3" },
  { qKey: "faq.q4", aKey: "faq.a4" },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      <section id="safety" className="mx-auto max-w-[1280px] px-4 md:px-6 pt-16 md:pt-20">
        <div className="flex flex-col md:flex-row gap-5 rounded-lg border border-background-200 bg-secondary-50 p-6 md:p-8">
          <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-800 shrink-0">
            <i className="ri-shield-check-line" />
          </span>
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950">
              {t("featured.safety.title")}
            </h3>
            <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
              {t("featured.safety.desc")}
            </p>
            <p className="mt-3 text-xs text-foreground-500 leading-relaxed">
              {t("footer.disclaimer")}
            </p>
          </div>
        </div>
      </section>

      <section id="faq" className="mx-auto max-w-[1280px] px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-2xl">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
            {t("faq.title")}
          </h2>
          <p className="mt-3 text-foreground-600 leading-relaxed">
            {t("faq.subtitle")}
          </p>
        </div>

        <div className="mt-10 max-w-3xl space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.qKey}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="font-medium text-foreground-950">
                    {t(item.qKey)}
                  </span>
                  <span className="w-5 h-5 flex items-center justify-center text-foreground-500 shrink-0">
                    <i
                      className={`ri-add-line transition-transform ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {t(item.aKey)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}